

document.addEventListener("DOMContentLoaded", function () {
  new Swiper('.js-banner-container', {
    breakpoints: {
      320: {
        initialSlide: 0,
        slidesPerView: 1,
        navigation: {
          nextEl: '.js-slider-arrow-next',
          prevEl: '.js-slider-arrow-prev'
        },
        pagination: {
          el: swiperSlider.pagination,
          type: "bullets",
          clickable: true
        }
      }
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  let customDelay = +document.querySelector('#banner-delay')?.dataset["customDelay"] ?? 0;

  new Swiper('.js-auto-banner-container', {
    autoplay: true,
    delay: customDelay,
    breakpoints: {
      320: {
        initialSlide: 0,
        slidesPerView: 1,
        navigation: {
          nextEl: '.js-slider-arrow-next',
          prevEl: '.js-slider-arrow-prev'
        },
        pagination: {
          el: swiperSlider.pagination,
          type: "bullets",
          clickable: true
        }
      }
    }
  });
});

let bannerWrapper = document.querySelectorAll('.js-banner-container .swiper-wrapper');
let bannerNav = document.querySelectorAll('.js-banner-container .slider__nav');

if (bannerWrapper && bannerNav) {
  for (let i = 0; i < bannerWrapper.length; i++) {
    if (bannerWrapper[i].children.length == 1) {
      bannerNav[i].style.display = "none";
    }
  }
}
